module.exports = __webpack_public_path__ + "e7a106aa55cb2572e5814dc3ba442e54.svg";